import {getSelectList} from '@/service/question'
import util from '@/tools/commonUtil'
const getLevelDataFn = _ => {
  const levelData = []
  return async config => {
    if (!levelData.length) {
      const param = {
        quId: config.questionId,
        paramInt01: config.answerConfig.paramInt01
      }
      const ret = await getSelectList(param)
      levelData.push(...ret)
    }
    return levelData
  }
}
const getLevelData = getLevelDataFn()

const validQuLogics = async function (question, logic, quItem, toQuItem, value, anQuItemId) {
  let isShow = true
  const levelData = await getLevelData(quItem)
  const { chooseType, logicType } = logic
  if (logicType === '1' || logicType === '2') {
    isShow = commonValidLogic(chooseType, value, anQuItemId, levelData)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(chooseType, value, anQuItemId, levelData)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId) {
  let resultStr = true
  const { chooseType } = logic
  resultStr = !commonValidLogic(chooseType, value, anQuItemId)
  return resultStr
}

const commonValidLogic = (chooseType, value, anQuItemId) => {
  let isShow = true
  if (chooseType === '1') {
    if (util.isContainsArr(value, anQuItemId)) {
      isShow = false
      return false
    }
  } else if (chooseType === '2') {
    if (!util.isContainsArr(value, anQuItemId)) {
      isShow = false
      return false
    }
  }
  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/SelectBox/logic.js